import { CssBaseline, ThemeProvider } from "@mui/material";
import { useEffect } from "react";

import { Router } from "./Router";
import { tutorialStart } from "./dev2dev/tutorial";
import { fetchGetPlayerData, fetchTelegramAuth } from "./store";
import { theme } from "./theme/theme";

async function onStart() {
  await telegramSetup();
  await fetchGetPlayerData();
  await setupDev2Dev();
}

async function telegramSetup() {
  await waitForTelegramSDK();

  const webAppVersion = Number.parseInt(window.Telegram.WebApp.version);
  if (webAppVersion >= 8) {
    window.HackneyGamesSDK.setup({ botName: "TokenValley_bot" });
    // comment on local development
    window.Telegram.WebApp.requestFullscreen();
    window.Telegram.WebApp.disableVerticalSwipes();
    window.Telegram.WebApp.SettingsButton.onClick(() => {
      window.location.href = "/settings";
    });
    window.Telegram.WebApp.SettingsButton.show();
  }
  await fetchTelegramAuth();
}

async function setupDev2Dev() {
  window.devtodev.initialize("50efdcd5-f73e-0c20-8b85-2f97a49626f6", {
    userId: window.Telegram.WebApp.initDataUnsafe.user?.id,
    currentLevel: 1,
  });
  tutorialStart();
}

async function waitForTelegramSDK(): Promise<void> {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (window.Telegram) {
        clearInterval(interval);
        resolve();
      }
    }, 100);
  });
}

function App() {
  useEffect(() => {
    onStart();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router />
    </ThemeProvider>
  );
}

export default App;
